/**
 * The LOCAL calendar day of an ISO timestamp.
 *
 * **Never `iso.slice(0, 10)`**, and never
 * `new Date(iso).toISOString().slice(0, 10)`. Both give the UTC day, which
 * rolls forward for any local time past UTC midnight -- a 5pm Pacific reading
 * buckets under tomorrow's date. This has been a real bug in two sibling apps.
 * `getFullYear`/`getMonth`/`getDate` read the local calendar, which is what a
 * user means by "the day this happened".
 *
 * An unparseable timestamp yields "" rather than "NaN-NaN-NaN": the caller
 * renders it as unknown instead of as a date that looks almost right.
 *
 * This lives in its own module rather than inside a page's logic file. In the
 * template it shipped inside `itemsPage.ts` -- the worked example the template
 * explicitly tells you to delete -- while `chartData.ts`, which is NOT part of
 * that example, imported it. Deleting the example therefore broke typecheck,
 * vitest and the build at once. A helper that encodes a general correctness
 * rule does not belong in a file whose docstring says "delete this".
 */
export function localDay(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
